module.exports = __webpack_public_path__ + "static/media/EVEN.ab5e23e3.png";